module.exports = "<template>\n\t<router-view></router-view>\n</template>\n";